<template>
	<div>
		<div class="form-section-base__block-outer">
			<div class="form-section-base__block-inner">
				<slot></slot>
				<v-row>
					<v-col cols="12">
						<DadataOrgField
							v-model="v.name.$model"
							:errorMessages="getValidationErrorText(v.name)"
							label="Наименование, указанное в ЕГРЮЛ"
							outlined
							:suggestions="suggestions"
							field="name"
							@suggest="onSelect"
						/>
					</v-col>

					<v-col cols="4">
						<DadataOrgField
							v-model="v.ogrn.$model"
							:errorMessages="getValidationErrorText(v.ogrn)"
							:mask="Mask.OGRN"
							label="ОГРН"
							outlined
							:disabled="
            isFieldDisabled || v.mrpDisabled.$model.includes(FieldName.OGRN)
          "
							:suggestions="suggestions"
							field="ogrn"
							@suggest="onSelect"
						/>
					</v-col>
					<v-col cols="4">
						<DadataOrgField
							v-model="v.inn.$model"
							:errorMessages="getValidationErrorText(v.inn)"
							:mask="Mask.INN_ORG"
							label="ИНН"
							outlined
							:disabled="
            isFieldDisabled || v.mrpDisabled.$model.includes(FieldName.INN)
          "
							:suggestions="suggestions"
							field="inn"
							@suggest="onSelect"
						/>
					</v-col>
					<v-col cols="4">
						<v-text-field
							v-model="v.kpp.$model"
							:errorMessages="getValidationErrorText(v.kpp)"
							v-mask="KPP"
							label="КПП"
							outlined
							:disabled="isFieldDisabled"
						/>
					</v-col>
				</v-row>

				<AddressEGRUL :v="v" notice-recovery :translationKey="translationKey ? `${translationKey}.egrul` : undefined"/>

				<v-row>
					<v-col cols="4">
						<DateFieldCustom
							label="Дата гос. регистрации"
							:value="v.regDate.$model"
							@change="v.regDate.$model = $event"
							:errorMessage="v.regDate"
							:max="new Date().toISOString()"
							@blur="v.regDate.$touch"
						/>
					</v-col>
					<v-col cols="4">
						<v-text-field
							v-model="v.email.$model"
							:errorMessages="getValidationErrorText(v.email)"
							label="Адрес электронной почты"
							outlined
							:disabled="isFieldContactsDisabled"
							@blur="v.email.$touch"
						/>
					</v-col>
					<v-col cols="4">
						<v-text-field
							v-model="v.phone.$model"
							:errorMessages="getValidationErrorText(v.phone)"
							v-mask="Mask.PHONE"
							label="Контактный телефон"
							outlined
							@blur="v.phone.$touch"
						/>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import {and, maxLength, minLength, required} from 'vuelidate/lib/validators';
import {
	getValidationErrorText,
	EMOJI,
	EMAIL,
	DATE_FORMAT,
	DATE_FUTURE,
	DATE_PAST,
	MAX_LENGTH_EMAIL,
	INN,
	KPP, TRAILING_AND_LEADING_SPACES,
} from '@/utils/validate';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import DadataOrgField from '@/components/base/DadataOrgField';

import AddressEGRUL from '@/components/services/NoticeRecovery/General/AddressEGRUL';
import {addressValidate} from '@/components/base/AddressStructuredField';
import {FieldName, Mask} from '@/constants';

export const organizationModel = {
	name: '',
	address: '',
	addressesMatch: false,
	factAddress: '',
	ogrn: '',
	regDate: '',
	inn: '',
	kpp: '',
	email: '',
	phone: '',
	mrpDisabled: [],
};

export const organizationValidation = {
	name: {
		required,
		maxLength: maxLength(1000),
		EMOJI,
		TRAILING_AND_LEADING_SPACES
	},
	address: {
		required,
		...addressValidate(),
		TRAILING_AND_LEADING_SPACES
	},
	addressesMatch: {},
	factAddress: {
		required,
		...addressValidate(),
		TRAILING_AND_LEADING_SPACES
	},
	ogrn: {
		required,
		minLength: minLength(13),
	},
	regDate: {
		required,
		DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
	},
	inn: {
		required,
		minLength: minLength(10),
		INN: INN(10),
	},
	kpp: {
		required,
		minLength: minLength(9),
		KPP,
	},
	email: {
		required,
		EMAIL,
		maxLength: maxLength(MAX_LENGTH_EMAIL),
		TRAILING_AND_LEADING_SPACES
	},
	phone: {
		required,
		minLength: minLength(16),
	},
	mrpDisabled: {},
};

export default {
	name: 'Organization',
	props: {
		v: {
			type: Object,
			required: true,
		},
		isAlternativeServiceEdit: {
			type: Boolean,
			required: true,
		},
		isManual: {
			type: Boolean,
			default: true,
		},
		translationKey: {
      type: String,
    }
	},
	components: {
		AddressEGRUL,
		DateFieldCustom,
		DadataOrgField,
	},
	data: () => ({
		suggestions: [],
		FieldName,
		Mask,
		getValidationErrorText,
	}),
	computed: {
		isFieldDisabled() {
			if (!this.isManual) return false;

			return this.isManual && this.isAlternativeServiceEdit;
		},

		isFieldContactsDisabled() {
			if (!this.isManual) return false;

			return this.isManual && this.isAlternativeServiceEdit;
		},
	},
	methods: {
		onSelect: function (item) {
			this.suggestions = [item];
			this.v.name.$model = item.name;
			this.v.inn.$model = item.inn;
			this.v.ogrn.$model = item.ogrn;
			this.v.kpp.$model = item.kpp;
			this.v.regDate.$model = item.regDate;
			this.v.email.$model = item.email;
			this.v.address.$model = {...item.address};
			this.v.addressesMatch.$model = true;
		}
	}
};
</script>
